import $ from 'jquery';
import ImageCredits from './image-credits';

/* global x5script, initStatusMap */

class StatewideStatus {
  constructor() {
    this.statewideStatusBlock = $('.js-bss');
    this.loaderHtml = x5script.loaderHtml;

    if (!this.statewideStatusBlock.length) {
      return;
    }

    this.displayLoader = false;
    this.isInitial = true;

    this.imageCredits = new ImageCredits();

    this.contentInit();
    this.contentChange();
    this.windowPopState();
  }

  windowPopState() {
    window.onpopstate = e => {
      if (e.state !== null && 'fishStatus' in e.state) {
        const state = e.state.fishStatus;

        this.windowHash = `${state}`;
        this.initialLoad();
      }
    };
  }

  initialLoad() {
    if (this.windowHash) {
      const fishSlug = this.windowHash;
      const activeTab = this.statewideStatusTabs.find(
        `.js-bss-tab[href="${fishSlug}"]`,
      );

      this.scrollTo = activeTab;

      activeTab.trigger('click');
      if (activeTab.length) {
        if (fishSlug === this.fishSlug) {
          this.loadContent();
        } else {
          this.tabLink = activeTab;
          this.changeContent();
        }
      } else {
        this.loadContent();
      }
    } else {
      this.loadContent();
    }
  }

  contentInit() {
    this.isLoading = false;
    this.statewideStatusTabs = this.statewideStatusBlock.find('.js-bss-tabs');
    this.activeTab = this.statewideStatusTabs.find('.js-bss-tab.is-active');
    this.content = this.statewideStatusBlock.find('.js-bss-content');
    this.statewideStatusTabLinks = this.statewideStatusTabs.find('.js-bss-tab');

    if (this.activeTab.length) {
      this.fishStatus = this.activeTab.data('tab-id');
      this.fishSlug = this.activeTab.attr('href');

      this.windowHash = window.location.hash;

      this.initialLoad();
    }
  }

  contentChange() {
    this.statewideStatusTabs.on('click', '.js-bss-tab', e => {
      e.preventDefault();
      if (this.isLoading) {
        return;
      }

      const tabLink = $(e.currentTarget);

      if (tabLink.hasClass('is-active')) {
        return;
      }

      this.tabLink = tabLink;
      this.changeContent();
    });
  }

  changeContent() {
    this.fishStatus = this.tabLink.data('tab-id');
    this.fishSlug = this.tabLink.attr('href');

    this.statewideStatusTabLinks
      .not(this.tabLink)
      .removeClass('is-active')
      .attr('aria-current', false);
    this.tabLink.addClass('is-active').attr('aria-current', true);

    this.displayLoader = true;
    this.loadContent();
  }

  loadContent() {
    if (this.displayLoader) {
      this.showLoader();
    }

    this.isLoading = true;

    const data = {
      action: 'load_statewide_status',
      fish_status: this.fishStatus,
      security: x5script.security2,
    };

    $.post(x5script.ajaxurl, data, response => {
      if (response.ok) {
        const { html } = response;
        this.content
          .hide()
          .css({ opacity: 0, height: 'auto', display: 'block' })
          .html(html);

        initStatusMap(this.fishSlug.substr(1));
        this.imageCredits.init();

        this.content.stop().animate({ opacity: 1 }, 300, () => {
          this.isLoading = false;

          if (this.isInitial) {
            this.scrollDown();
            this.isInitial = false;
          }
        });

        if (
          window.history.state !== null &&
          'fishStatus' in window.history.state
        ) {
          if (window.history.state.fishStatus !== this.fishSlug) {
            window.history.pushState(
              { fishStatus: this.fishSlug },
              document.title,
              `${this.fishSlug}`,
            );
          }
        } else {
          window.history.pushState(
            { fishStatus: this.fishSlug },
            document.title,
            `${this.fishSlug}`,
          );
        }
      } else {
        this.statewideStatusBlock
          .find('.js-loader')
          .parent()
          .after(
            `<p class="" style="color:#c00;margin-top:5px;text-align:center;">${
              response.error
            }</p>`,
          );
      }
    }).fail((xhr, status, error) => {
      this.statewideStatusBlock
        .find('.js-loader')
        .parent()
        .after(
          `<p class="" style="color:#c00;margin-top:5px;text-align:center;">${error}</p>`,
        );
    });
  }

  scrollDown() {
    if (typeof this.scrollTo === 'undefined') {
      return;
    }

    if (this.scrollTo.length) {
      $('html, body')
        .stop()
        .animate(
          {
            scrollTop: this.scrollTo.offset().top - 50,
          },
          500,
        );
    }
  }

  showLoader() {
    this.content
      .css({ height: this.content.height() })
      .html(`<div class="c-bss-loader">${this.loaderHtml}</div>`);
  }
}

export default new StatewideStatus();



// WEBPACK FOOTER //
// ./src/scripts/modules/statewide-status.js